module.exports = {"370124001":"榆山街道","370124002":"锦水街道","370124102":"东阿镇","370124103":"孝直镇","370124104":"孔村镇","370124105":"洪范池镇","370124106":"玫瑰镇","370124107":"安城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370124.json
// module id = 1256
// module chunks = 0